export const LISTE_MOIS_COMPTABLE = {
  title: 'Liste des mois comptables',
  breadcrumb: {
    home: 'Accueil',
    liste: 'Liste des mois comptables',
  },
  actions: {
    add: 'Nouveau mois comptable',
    search: 'Rechercher',
    filtre: 'Filtre',
  },
  tab: {
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    etat: 'Etat',
    exerciceComptable: 'Exercice comptable',
  },
  filtre: {
    etats: 'Etats',
    periode: 'Période',
    au: 'au',
    exercices: 'Exercices comptable',
  },
};

export const ADD_MOIS_COMPTABLE = {
  title: {
    ajout: 'Création d\'un mois comptable',
    edit: 'Modification du mois comptable',
  },
  breadcrumb: {
    add: 'Création mois comptable',
    edit: 'Modification mois comptable',
    racine: 'Accueil',
    liste: 'Liste des mois comptables',
  },
  actions: {
    cancel: 'Annuler',
  },
  tab: {
    information: 'Mois comptable',
  },
  validation: {
    exerciceComptable: 'Le champs exercice comptable est obligatoire',
    moisComptableChevauchement: 'Il y a un chevauchement des date de début et de fin entre ce mois comptable et les mois comptable enregistré.',
  },
  information: {
    title: 'Informations générales',
    dateDebut: 'Date début',
    dateFin: 'Date fin',
    etat: 'Etat',
    exerciceComptable: 'Exercice comptable',
  },
  notifications: {
    successCreation: 'Création du mois comptable réalisée avec succès.',
    successChange: 'Modification du mois comptable réalisée avec succès.',
  },
  etatType: {
    clos: 'Clos',
    ouvert: 'Ouvert',
  },
};

export const DETAIL_MOIS_COMPTABLE = {
  title: 'Détail mois comptable: {periode}',
  breadcrumb: {
    racine: 'Accueil',
    liste: 'Liste des mois comptable',
    detail: 'Détail mois comptable',
  },
  actions: {
    editionCommerciaux: 'Com. vendeur (PDF)',
    editionCommerciauxAnterieures: 'Com. Antérieures vendeur (PDF)',
  },
  tab: {
    info: 'Informations',
    comVendeur: 'Com. vendeur',
    comFournisseur: 'Com. fournisseur',
    commissionsAnterieuresVendeur: 'Com. antérieures vendeur',
    commissionsAnterieuresFournisseur: 'Com. antérieures fournisseur',
    commissionsGaranties: 'Com. garanties',
    commissionsRegrpGaranties: 'Com. garanties (regroupements produit)',
    tooltip: {
      commissionsGarantiesAGenerer: 'Des commissions sont en attente de génération',
    },
  },
  information: {
    title: 'Informations générales',
    dateDebut: 'Date début :',
    dateFin: 'Date fin :',
    etat: 'Etat :',
    exerciceComptable: 'Exercice comptable :',
  },
};
